import moment from 'moment';
import i18next from 'i18next';

function DateParser() {}

/**
 * Parses an integer value which is an epoch timestamp (seconds since Thursday, 1 January 1970).
 *
 * Ex. 1393500680
 *
 * @param value the value to parse.
 */
DateParser.parseEpoch = function(value) {
    return new Date(value);
};

/**
 * Parses a string in several variations of the ISO format.  These formats include:
 * YYYY-MM-DDTHH:mm:ss.SSS, YYYY-MM-DD HH:mm:ss, and YYYY-MM-DD.
 *
 * Ex.  2014-02-27
 *      2014-02-27 12:34:00
 *      2014-02-26T06:00:00.0
 *
 * @param value
 */
DateParser.parseISO = function(value) {
    return moment(value).toDate();
};

/**
 * Parses a string in several variations of the ISO format, but assumes value is in GMT.  These formats include:
 * YYYY-MM-DDTHH:mm:ss.SSS, YYYY-MM-DD HH:mm:ss, and YYYY-MM-DD.
 *
 * Ex.  2014-02-27
 *      2014-02-27 12:34:00
 *      2014-02-26T06:00:00.0
 *
 * @param value
 */
DateParser.parseISOUTC = function(value) {
    return moment.utc(value).toDate();
};

/**
 * Parses a time value and returns an integer that represents the number of seconds that have elapsed since
 * midnight. Format will be like "2:38 PM"
 *
 *
 * @param timeString
 * @returns the number of seconds since the beginning of the day.
 */
DateParser.parseTime = function(timeString) {
    var hour = 0;
    var minutes = 0;
    var amOrPm = '';

    var parts = timeString.split(/:| /);
    if (parts.length >= 2) {
        hour = +parts[0];
        minutes = parts[1];

        if (parts.length > 3) {
            // Some translations for AM and or PM have spaces
            amOrPm = parts.slice(2).join(' ');
        } else {
            amOrPm = parts[2];
        }

        var result = hour * 3600 + minutes * 60;

        // handle noon/midnight outliers...
        // The translation of am or pm might be cached, so we need to handle if it's showing 'AM' or 'PM'
        if ((amOrPm === i18next.t('common:PM') || amOrPm === 'PM') && hour !== 12) {
            result += 43200;
        } else if ((amOrPm === i18next.t('common:AM') || amOrPm === 'AM') && hour === 12) {
            result -= 43200;
        }

        return result;
    }

    return 0;
};

export default DateParser;
